export default __webpack_public_path__ + "static/media/simplify-shipping-dashboard.881734ea.png";